const EMAIL = 'creative@kayzar.com.au';
const PHONE = '+61 411 323 778';

export { EMAIL, PHONE };
